$('.video_outer').slick({
  dots: false,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});

$('.blog_posts_wrap').slick({
  dots: false,
  infinite: false,
  arrows: false,
  speed: 300,
  vertical: true,         // vertical on desktop
  verticalSwiping: true,  // vertical swipe on desktop
  slidesToShow: 2,
  slidesToScroll: 1,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 768,   // below 768px (mobile)
      settings: {
        vertical: false,        // switch to horizontal
        verticalSwiping: false, // disable vertical swipe
        slidesToShow: 1,
        dots: true, 
        slidesToScroll: 1
      }
    }
  ]
});


let wheelTimeout;

// Function to check if current device is desktop
function isDesktop() {
  return window.matchMedia("(min-width: 768px)").matches;
}

// Only attach wheel event on desktop
if (isDesktop()) {
  $('.blog_posts_wrap').on('wheel', function(e) {
    let slick = $(this).slick('getSlick');
    let currentSlide = slick.currentSlide;
    let totalSlides = slick.slideCount;
    let slidesToShow = slick.options.slidesToShow;

    let scrollingDown = e.originalEvent.deltaY > 0;
    let scrollingUp = e.originalEvent.deltaY < 0;

    let atLastSlide = currentSlide >= totalSlides - slidesToShow;
    let atFirstSlide = currentSlide <= 0;

    // Only preventDefault and slide if not at edges
    if ((scrollingDown && !atLastSlide) || (scrollingUp && !atFirstSlide)) {
      e.preventDefault();

      if (wheelTimeout) return;

      if (scrollingDown) {
        $(this).slick('slickNext');
      } else if (scrollingUp) {
        $(this).slick('slickPrev');
      }

      wheelTimeout = setTimeout(() => {
        wheelTimeout = null;
      }, 200);  // throttle duration
    }
    // else: don't preventDefault — let the page scroll normally at edges
  });
}




$('.testimonial_right_inner').slick({
  dots: false,
  infinite: false,
  arrows: false,
  speed: 300,
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 1,
        adaptiveHeight: true // only works with vertical: false
      }
    }
  ]
});

function updateBodyClassForLastSlide() {
  let slick = $('.testimonial_right_inner').slick('getSlick');
  let currentSlide = slick.currentSlide;
  let totalSlides = slick.slideCount;
  let slidesToShow = slick.options.slidesToShow;

  // Check if we are at or beyond the last visible slide
  let atLastSlide = currentSlide >= totalSlides - slidesToShow;

  if (atLastSlide) {
    $('body').addClass('testimonial_last_slide');
  } else {
    $('body').removeClass('testimonial_last_slide');
  }
}

function isDesktop() {
  return window.matchMedia("(min-width: 768px)").matches;
}

// Run on init and on slide change
$('.testimonial_right_inner').on('init afterChange', function() {
  updateBodyClassForLastSlide();
});

// Initialize slick (re-trigger afterChange for initial check)
$('.testimonial_right_inner').slick('setPosition');

if (isDesktop()) {
  $('.testimonial_right_inner').on('wheel', function(e) {
    let slick = $(this).slick('getSlick');
    let currentSlide = slick.currentSlide;
    let totalSlides = slick.slideCount;
    let slidesToShow = slick.options.slidesToShow;

    let scrollingDown = e.originalEvent.deltaY > 0;
    let scrollingUp = e.originalEvent.deltaY < 0;

    let atLastSlide = currentSlide >= totalSlides - slidesToShow;
    let atFirstSlide = currentSlide <= 0;

    if (scrollingDown) {
      if (!atLastSlide) {
        e.preventDefault();
        $(this).slick('slickNext');
      }
    }

    if (scrollingUp) {
      if (!atFirstSlide) {
        e.preventDefault();
        $(this).slick('slickPrev');
      }
    }
    
    // After changing slide, update the body class
    setTimeout(updateBodyClassForLastSlide, 10); // Slight delay to wait for slide to update
  });
}




// $('.insta_slide_inner').slick({
//   dots: false,
//   infinite: true,
//   arrows: true,
//   centerMode: true,
//   speed: 1000,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   appendArrows: $('.custom_slide_arrows'),
//   prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' +
//                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
//                '<path d="M6.75 15.75L3 12M3 12L6.75 8.25M3 12L21 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
//                '</svg>' +
//              '</button>',
//   nextArrow: '<button type="button" class="slick-next" aria-label="Next">' +
//                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
//                '<path d="M17.25 8.25L21 12M21 12L17.25 15.75M21 12H3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
//                '</svg>' +
//              '</button>',
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 3,
//         centerMode: true,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         centerMode: true,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         centerMode: true,
//         arrows: true
//       }
//     }
//   ]
// });
document.querySelectorAll('.footer-block').forEach((block, index) => {
  block.addEventListener('click', function () {

    if (index === 0) return;
    if (index === 3) return;
    if (index === 4) return;

    const isActive = block.classList.contains('active');

    document.querySelectorAll('.footer-block').forEach(item =>
      item.classList.remove('active')
    );

    if (!isActive) {
      block.classList.add('active');
    }
  });
});

// $('.banner_with_text_wrap').slick({
//   dots: false,
//   infinite: false,
//   arrows: true,
//   speed: 300,
//   vertical: false,
//   verticalSwiping: false,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   appendArrows: $('.custom_video_slider_arrow'),
//   prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">
//     <svg xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16" fill="none">
//       <path d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V8V7ZM27.7071 8.70711C28.0976 8.31658 28.0976 7.68342 27.7071 7.29289L21.3431 0.928932C20.9526 0.538408 20.3195 0.538408 19.9289 0.928932C19.5384 1.31946 19.5384 1.95262 19.9289 2.34315L25.5858 8L19.9289 13.6569C19.5384 14.0474 19.5384 14.6805 19.9289 15.0711C20.3195 15.4616 20.9526 15.4616 21.3431 15.0711L27.7071 8.70711ZM1 8V9H27V8V7H1V8Z" fill="#C87E8C"/>
//     </svg>
//   </button>`,
//   nextArrow: `<button type="button" class="slick-next" aria-label="Next">
//     <svg xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16" fill="none">
//       <path d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V8V7ZM27.7071 8.70711C28.0976 8.31658 28.0976 7.68342 27.7071 7.29289L21.3431 0.928932C20.9526 0.538408 20.3195 0.538408 19.9289 0.928932C19.5384 1.31946 19.5384 1.95262 19.9289 2.34315L25.5858 8L19.9289 13.6569C19.5384 14.0474 19.5384 14.6805 19.9289 15.0711C20.3195 15.4616 20.9526 15.4616 21.3431 15.0711L27.7071 8.70711ZM1 8V9H27V8V7H1V8Z" fill="#C87E8C"/>
//     </svg>
//   </button>`
// });


// $('.banner_with_text_wrap').on('wheel', function(e) {
//   e.preventDefault();

//   const $slider = $(this);
//   const slick = $slider.slick('getSlick');
//   const currentSlide = slick.currentSlide;
//   const totalSlides = slick.slideCount;

//   if (e.originalEvent.deltaY < 0) {
//     // Scroll up
//     if (currentSlide > 0) {
//       $slider.slick('slickPrev');
//     }
//   } else {
//     // Scroll down
//     if (currentSlide < totalSlides - 1) {
//       $slider.slick('slickNext');
//     }
//   }
// });


jQuery(document).ready(function ($) {
  var $slider = $('.video_slider_inner');
  var slickInitialized = false;

  function initSlickIfMobileOrTablet() {
    var windowWidth = $(window).width();

    if (windowWidth < 768) {
      // Mobile
      if (!slickInitialized) {
        $slider.slick({
          dots: false,
          centerMode: true,
          arrows: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
        slickInitialized = true;
      }
    } else if (windowWidth >= 768 && windowWidth <= 1024) {
      // Tablet
      if (!slickInitialized) {
        $slider.slick({
          dots: false,
          centerMode: true,
          arrows: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1
        });
        slickInitialized = true;
      }
    } else {
      // Desktop (unslick)
      if (slickInitialized) {
        $slider.slick('unslick');
        slickInitialized = false;
      }
    }
  }

  initSlickIfMobileOrTablet();

  $(window).on('resize', function () {
    initSlickIfMobileOrTablet();
  });
});


  /*===============Thumbnail Slider================*/
// function initVerticalSlider() {
//   if ($(window).width() > 1024) {
//     if (!$('.my_verts').hasClass('slick-initialized')) {
//       $('.my_verts').slick({
//         vertical: true,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         infinite: false,
//         speed: 300,
//         dots: false,
//         arrows: true,
//         prevArrow: `<div class="slick-prev custom-arrow">
//           <svg class="faq-icon" width="16" height="16" viewBox="0 0 16 16">
//             <path d="M2 11l6-6 6 6" stroke="white" stroke-width="2" fill="none"></path>
//           </svg>
//         </div>`,
//         nextArrow: `<div class="slick-next custom-arrow">
//           <svg class="faq-icon" width="16" height="16" viewBox="0 0 16 16">
//             <path d="M2 5l6 6 6-6" stroke="white" stroke-width="2" fill="none"></path>
//           </svg>
//         </div>`
//       });
//     }
//   } else {
//     if ($('.my_verts').hasClass('slick-initialized')) {
//       $('.my_verts').slick('unslick');
//     }
//   }
// }

// $(document).ready(function () {
//   initVerticalSlider();
// });

// $(window).on('resize', function () {
//   initVerticalSlider();
// });
$(document).ready(function () {
  const $slider = $('.center_image_main');

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,           // autoplay enabled for both mobile and desktop
    autoplaySpeed: 2000,      // 3 seconds per slide, adjust if needed
    infinite: true,           // infinite loop
    arrows: false,
    dots: false,
    cssEase: 'ease',
    fade: true,              // fade off for both
    vertical: false           // horizontal slide for both
  });

  // Removed wheel scroll navigation completely
});
 document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.toggle-button').forEach(button => {
      button.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        const content = document.getElementById(targetId);

        content.classList.toggle('expanded');

        if (content.classList.contains('expanded')) {
          this.textContent = 'Show less';
        } else {
          this.textContent = 'Show more';
        }
      });
    });
  });





